import _ from 'lodash';
import intersection from 'lodash/intersection';
import mobx, { action, autorun, computed, observable, runInAction, toJS } from 'mobx';
import api from '../../api';
import { isObject, browser, setStyle } from '../../common';
import { get } from 'lodash';
import { SORT_BY } from '~/web-frontend-core/ws-api/const/base';
import { withRouter } from "react-router-dom";


export default class LineStore {

  @observable status = false;
  @observable isLoading = true;
  @observable loadingRoss = [];
  @observable trigger = 1;
  @observable mode = '';
  @observable lineSport = [];
  @observable lineLeague = new Map();
  @observable lineGames = new Map();
  @observable lineGamesDetails = new Map();
  @observable lineGamesOther = new Map();
  @observable result = {
    status: 0,
    text: '',
    type: 0
  };
  @observable lineMessage = {
    title: '',
    text: ''
  };
  @observable showTableItems = [];
  @observable showTableItemsAll = false;
  @observable showTableDopItems = [];
  @observable showTableDopBets = [];
  @observable filterTables = new Map();
  @observable firstLine = new Map();
  refreshTimer = null;
  loadTimer = null;
  @observable all = 1;
  /** @type {0|1} загружать ли допроспись при раскрытии */
  @observable ross = 0;
  @observable finishLoad = 0;
  @observable userToggleRoss = [];
  @observable dict = {};
  @observable offset = 0;
  @observable hasMore = true;
  @observable length = 50;
  @observable pagination = 0;
  @observable colCount = 2;
  @observable selected = {
    sport: [],
    league: [],
    games: [],
    type: '',
    popular: 0,
    popular_group: [],
    video: 0,
  };

  @observable timeLineFilter = [
    { val: 0, label: 'IRM_TIMELINE_0' },
    { val: 3600, label: 'IRM_TIMELINE_3600' },
    { val: 7200, label: 'IRM_TIMELINE_7200' },
    { val: 21600, label: 'IRM_TIMELINE_21600' },
    { val: 32400, label: 'IRM_TIMELINE_32400' },
    { val: 43200, label: 'IRM_TIMELINE_43200' },
    { val: 86400, label: 'IRM_TIMELINE_86400' }
  ];

  @observable timeLine = 0;
  @observable toggleRossGames = new Map();

  @observable statisticalCategories = new Map();
  @observable statisticalCategoriesLoading = [];
  @observable isShowTooltip = true;

  defaultMainTab = new Map();

  store = null;
  account = null;
  appStore = null;

  constructor(store, accountStore, appStore) {
    this.store = store;
    this.account = accountStore;
    this.appStore = appStore;
  }

  /**
   * Подсвечивать ли изменения live-коэф.
   */
  get highlightChanges() {
    return this.account.accountSettings.highlightChangesLive === 1 && this.mode == 'live';
  }

  @action setShowRoss(ross) {
    if (this.mode === 'live') {
      this.ross = ross ? 1 : 0;
      let games = [];
      if (this.selected.games.length) {
        games = this.selected.games;
      } else {
        games = this.lineGames.keys().map(v => Number(v));
      }
      games.forEach(id => {
        if (this.lineGames.has(id)) this.lineGames.get(id).sr = this.ross;
        if (this.ross) this.setToggleGames(id, this.lineGames.get(id).sid);
      });
      if (this.ross) {
        this.userToggleRoss = games;
      } else {
        this.userToggleRoss = [];
        this.removeToggleGames(null, null, 1);
      }
    }
  }

  @action setResult(text, type) {
    this.result.status = 1,
      this.result.text = text,
      this.result.type = type ? type : 0;
  }

  @action clearResult() {
    this.result.status = 0,
      this.result.text = '',
      this.result.type = 0;
  }

  @action init() {
    // if (!this.status) {
    this.mode = this.store.mode;
    this.ross = this.account.accountSettings.loadRossLive && this.mode == 'live' ? 1 : 0;
    // this.getData();
    this.status = true;
    this.colCount = this.mode == 'live' ? 2 : 3;
    // }
    autorun(() => {
      this.setShowRoss(this.account.accountSettings.loadRossLive);
    });
  }

  @action despose() {
    clearInterval(this.refreshTimer);
    this.status = false;
    this.mode = '';
    this.isLoading = true;
    this.lineSport = [];
    this.lineLeague.clear();
    this.lineGames.clear();
    this.lineGamesDetails.clear();
    this.lineGamesOther.clear();
    this.showTableItems = [];
    this.showTableItemsAll = false;
    this.showTableDopItems = [];
    this.showTableDopBets = [];
    this.filterTables.clear();
    this.userToggleRoss = [];
    this.toggleRossGames.clear();
    this.ross = 0;
    this.all = 0;
    this.hasMore = true;
    this.selected = {
      sport: [],
      league: [],
      games: [],
      type: '',
      popular: 0,
      video: 0,
    };
    this.offset = 0;
    this.length = 50;
    this.refreshTimer = null;
    this.colCount = 2;
    this.clearResult();
    this.clearLineMessage();
    this.statisticalCategories.clear();
    this.statisticalCategoriesLoading = [];
  }

  @action getData() {
    return api[this.mode].getData().then(
      action(
        data => {
          if (data.result) {
            this.selected.sport = data.result.sport;
            this.selected.league = data.result.league;
            this.selected.games = data.result.games;
            this.selected.games = data.result.games;
            this.all = parseFloat(data.result.all);
            this.onlyview = parseFloat(data.result.onlyview);
            this.loadLine();
          } else {
            this.setResult(data.text ? data.text : 'SERVER_TEMPORARILY_DOWN');
          }
        })
    )
      .catch(action(err => {
        this.setResult('SERVER_TEMPORARILY_DOWN');
      }));
  }

  @action setLineMessage(title, text) {
    this.lineMessage.title = title;
    this.lineMessage.text = text;
  };

  @action clearLineMessage() {
    this.lineMessage.title = '';
    this.lineMessage.text = '';
  }

  loadLine = action(() => {
    let attempt = 0;
    this.clearResult();
    this.clearLineMessage();
    clearTimeout(this.loadTimer);
    return api[this.mode].get(this.ross, this.all, mobx.toJS(this.selected), this.getRossGamesLoad(), this.offset, this.length, this.timeLine, this.appStore.cashboxMode).then(
      action(
        data => {
          if (isObject(data)) {
            if (data.sport) {
              this.dict = data.dict;
              this.addSport(data.sport);
              this.addLeague(data.league);
              this.addGame(data.games);
              this.addGameDetails(data.t_b);
              if (this.mode == 'line') {
                if (data.pagination.slice == 0) this.hasMore = false;
              }
            } else {
              if (this.mode == 'line') {
                // if (this.store.menu.sport.size > 0) {
                // 	this.selectItem({sport: this.store.menu.sport.keys(), league: [], games: []}, 1);
                // } else {
                this.lineSport = [];
                if (this.timeLine != 0) {
                  // this.setResult('За выбранный период событий нет. Пожалуйста сбросте фильтр или выберите другой период');
                  this.setLineMessage('За выбранный период событий нет', 'Пожалуйста выберите другой период');
                } else {
                  this.setResult('Событие не найдено. Пожалуйста, выберите интересующее событие в левом меню');
                }
                // this.errorLine.text = 'Нет выбранных событий';
                // }
              }
            }
            // this.setDivmainScroll();
            if (this.mode === 'live') {
              this.subscribeListMatchesWS().catch(action(() => {
                this.isLoading = false;
                this.refreshLine();
              }));
              return;
            }
            this.isLoading = false;
            this.refreshLine();
            // if (this.mode == 'live') {
            // 	const time = this.countSelectGames == 1 ? this.store.liveRefreshOne : this.store.liveRefreshInterval;
            // 	this.refreshTimer = setTimeout(() => this.loadLine(), this.mode == 'live' ? time : 10000000);
            // }
          } else if (data == null) {
            this.isLoading = false;

            if (this.mode == 'line') {
              this.lineSport = [];
              if (this.timeLine != 0) {
                // this.setResult('За выбранный период событий нет. Пожалуйста сбросте фильтр или выберите другой период');
                this.setLineMessage('За выбранный период событий нет', 'Пожалуйста выберите другой период');
              } else {
                this.setResult('Событие не найдено. Пожалуйста, выберите интересующее событие в левом меню');
              }
            }
          } else {
            if (attempt < 5) {
              attempt++;
              this.loadTimer = setTimeout(() => this.loadLine(), 3000);
            } else {
              this.setResult('SERVER_TEMPORARILY_DOWN');
            }
          }
        })
    )
      .catch(action(err => {
        this.setResult('SERVER_TEMPORARILY_DOWN');
      }));
  })

  refreshLine = action(() => {
    if (!this.mode || this.mode !== 'live') return false;
    this.refreshRossStatisticalTables();
    return api[this.mode].get(this.ross, this.all, mobx.toJS(this.selected), this.getRossGamesLoad(), this.offset, this.length, this.timeLine, this.appStore.cashboxMode).then(
      action(data => {
        if (data && data.sport) {
          this.dict = data.dict;
          this.addSport(data.sport);
          this.addLeague(data.league);
          this.addGame(data.games);
          this.addGameDetails(data.t_b);
          // this.checkGamesUpdate();
          // } else {
          // this.selectItem({sport: [], league: [], games: []}, 1);
        }
        // this.setDivmainScroll();

        const time = this.countSelectGames == 1 ? this.store.liveRefreshOne : this.store.liveRefreshInterval;
        this.refreshTimer = setTimeout(() => this.refreshLine(), this.mode == 'live' ? time : 10000000);

      }));
    // .catch(action(err => {
    // 	this.setResult('SERVER_TEMPORARILY_DOWN');
    // }))
  })

  @action loadMore() {
    this.offset += this.length;
    return api[this.mode].get(this.ross, this.all, mobx.toJS(this.selected), this.getRossGamesLoad(), this.offset, this.length, this.timeLine, this.appStore.cashboxMode).then(
      action(data => {
        if (data.sport) {
          this.gluing(data);
          // this.checkGamesUpdate();
        } else {
          this.hasMore = false;
        }
        // this.setDivmainScroll();
      }));
    // .catch(action(err => {
    // 	this.setResult('SERVER_TEMPORARILY_DOWN');
    // }))
  }

  gluing(data) {
    if (data.pagination && data.pagination.slice == 0) this.hasMore = false;
    this.dict = { ...this.dict, sport: data.dict.sport, league: data.dict.league, cmd: data.dict.cmd };
    data.sport.forEach(item => {
      const s = this.lineSport.findIndex((el, index) => el.id == item.id);
      if (s != -1) {
        // this.lineSport[s].league = this.lineSport[s].league.concat(item.league];
        this.lineSport[s].league = _.union(this.lineSport[s].league, item.league);
      } else {
        item.name = this.dict.sport[item.id];
        this.lineSport.push(item);
      }
    });

    this.addLeague(data.league, 1);
    this.addGame(data.games);
    this.addGameDetails(data.t_b);

  }

  @action setData() {

    let data = {};
    const selected = mobx.toJS(this.selected);

    if (this.mode == 'live') {
      data = {
        all: this.all,
        ross: this.ross,
        onlyview: 0
      };

      if (selected.type == 1) data['sport'] = selected.sport;
      data['games'] = selected.games;
    } else if (this.mode == 'line') {
      data = {
        all: this.all,
        onlyview: 0,
        ross: this.ross,
        popular: this.selected.popular,
        timeline: this.timeLine,
        count: 0
      };
      switch (this.selected.type) {
        case 0:
          data.sport = selected.sport;
          data.league = selected.league;
          data.games = selected.games;
          break;
        case 1:
          data.sport = selected.sport;
          break;
        case 2:
          data.sport = selected.sport;
          data.league = selected.league;
          data.count = selected.games.length;
          break;
        case 3:
          data.sport = selected.sport;
          data.league = selected.league;
          data.games = selected.games;
          data.count = 1;
          break;
        case 4:
          data.sport = selected.sport;
          data.league = selected.league;
          break;
        case 5:
          data.sport = selected.sport;
          data.league = selected.league;
          break;
      }
    }

    try {
      return api[this.mode].setData(data).then(
        action(
          data => {
            if (data.code == 'OK') {

            }
          })
      )
        .catch(action(err => {
          this.setResult('SERVER_TEMPORARILY_DOWN');
        })
        );
    } catch (e) {
      console.log(this.mode)
    }


  }

  /**
   * @param {number[]} gamesID
   */
  @action loadLineRoss(gamesID = []) {
    if (gamesID.length === 0) { return; }
    this.loadingRoss = gamesID;
    // обновление допросписи по websocket доступно только для 1 раскрытого события
    this.requestOutcomesData(gamesID);
  }
  /**
  * Подписка на список live матчей по wss
  */
  subscribeListMatchesWS({ top } = { top: false }) {
    // const isFavPage = document.location.pathname.includes('favourites')
    // const selected = toJS(this.selected);
    // const matchIds = selected.games.length > 0 && selected.games;
    // const championshipsIds = matchIds.length === 0 && selected.league;
    // const sportIds = championshipsIds.length === 0 && selected.sport;
    // const favorites = (sportIds || championshipsIds || matchIds) && { sportIds, championshipsIds, matchIds };
    // const championshipId = !favorites && selected.league.length === 1 && selected.league[0];
    // const sportId = !favorites && !championshipId && selected.sport.length === 1 && selected.sport[0];

    const isFavPage = document.location.pathname.includes('favourites')
    const selected = toJS(this.selected);
    const matchIds = selected.games.length > 0 && selected.games;
    const championshipsIds = matchIds.length === 0 && selected.league;
    const sportIds = championshipsIds.length === 0 && selected.sport;
    const favorites = (sportIds || championshipsIds || matchIds) && {
      sportIds,
      championshipsIds,
      matchIds,
    };

    const championshipId = selected.league.length === 1 && selected.league[0];
    const sportId = !championshipId && selected.sport.length === 1 && selected.sport[0];

    // const video = selected.video;
    // const selectedParams = Object.assign(
    //   { sort: this.store.schedule.select.sort === 'abc' ? SORT_BY.ALPHABET : SORT_BY.PRIORITY },
    //   championshipId && { championshipId },
    //   favorites && isFavPage && {
    //     championshipsIds: championshipsIds || [],
    //     sportIds: sportIds || [],
    //     matchIds: matchIds || [],
    //     favorites: true,
    //   },
    //   favorites && !isFavPage && {
    //     singleMatch: true,
    //     id: matchIds[0],
    //   },
    //   sportId && { sportId },
    //   video && { video },
    //   top && { top },
    // );

    const video = selected.video;
    const selectedParams = Object.assign(
      { sort: this.store.schedule.select.sort === 'abc' ? SORT_BY.ALPHABET : SORT_BY.PRIORITY },
      championshipId && { championshipId },
      favorites && isFavPage && {
        championshipsIds: championshipsIds || [],
        sportIds: sportIds || [],
        matchIds: matchIds || [],
        favorites: true,
      },
      favorites && !isFavPage && matchIds.length === 1 && {
        singleMatch: true,
        id: matchIds[0],
      },
      sportId && { sportId },
      video && { video },
      top && { top },
    );

    /** Костыль, потому что метод постоянно вызывается из разных мест даже с одинаковыми params */
    if (JSON.stringify(selectedParams) === this.lastSelectedParams) {
      return Promise.resolve();
    }
    this.lastSelectedParams = JSON.stringify(selectedParams);
    return this.store.matchesList.listenWS(selectedParams);
  }
  /**
   * Подгрузка доп.росписи по xhr
   * @param {number[]} gameIDs
   */
  requestOutcomesData(gameIDs = []) {
    api[this.mode].getRoss(gameIDs).then((response) => {
      this.onOutcomesLoaded(response.result || response);
    }).catch(action(() => {
      this.onGameOutcomesLoaded(gameIDs);
      gameIDs.forEach((gameID) => {
        const endedGame = this.lineGames.get(gameID)
        endedGame.ross = false;
        endedGame.sr = false;
        const index = this.userToggleRoss.indexOf(gameID);
        if (index === -1) { return; }
        this.userToggleRoss.splice(index, 1);
        this.removeToggleGames(gameID, endedGame.sid);
      });
    }));
  }

  onOutcomesLoaded(data) {
    if (!data.t_b) {
      throw new Error('No Response Data!')
    }
    const loadedGamesID = Object.keys(data.t_b).map(Number);
    this.onGameOutcomesLoaded(loadedGamesID);
    this.addGameDetails(data.t_b);
  }

  @action onGameOutcomesLoaded(gamesID = []) {
    if (gamesID.length === 0) { return; }
    this.loadingRoss = this.loadingRoss.filter((gameID) => !gamesID.includes(gameID));
  }

  @action addSport(sport) {
    let s, d;
    // const lineSport = mobx.toJS(this.lineSport)
    if (sport && sport.length > 0) {
      _.pullAllWith(this.lineSport, sport, (x, y) => x.id != y.id);
      sport.forEach(item => {
        if (item.league.length === 0) return false;
        if (this.selected.sport.indexOf(item.id) != -1 || this.all || this.selected.popular_group && this.selected.popular_group.length) {
          s = this.lineSport.findIndex((el, index) => el.id == item.id);
          if (s != -1) {
            this.lineSport[s].league = item.league;
          } else {
            if (item.league)
              item.name = this.dict.sport[item.id];
            this.lineSport.push(item);
          }
        }
      });
    } else {
      this.lineSport = [];
    }

    this.setDefaultMainTab(sport);
  }

  @action setDefaultMainTab(sport) {
    if (!sport) return;

    Object.values(sport).forEach(item => {
      const tabs_ids = item.default_categories;

      if (tabs_ids && Array.isArray(tabs_ids))
        this.defaultMainTab.set(item.id, tabs_ids);
    });
  }

  @action addLeague(league, more) {
    let l;
    if (league) {
      for (const item in league) {
        if (this.lineLeague.has(item)) {
          if (more) {
            this.lineLeague.get(item).games = _.uniq(this.lineLeague.get(item).games.concat(league[item].games));
          } else {
            l = _.xor(mobx.toJS(this.lineLeague.get(item).games), league[item].games);

            if (l.length > 0) {
              // this.lineLeague.set(item, league[item]);
              this.lineLeague.get(item).games = league[item].games;
            }
          }
        } else {
          league[item]['show'] = this.showTableItemsAll;
          league[item]['name'] = this.dict.league[item];
          this.lineLeague.set(item, league[item]);
        }
      }
    }
  }

  @action addGame(games) {
    if (games) {
      const _g = [];
      for (const item in games) {
        if (this.lineGames.has(item)) {
          this.copyGame(item, games[item]);
        } else {
          games[item]['sr'] = this.ross;
          games[item]['c1'] = this.dict.cmd[games[item].c1_id];
          if (this.account.access && games[item].statistical_ids && (this.account.accountSettings.tooltip_union_stat_match === 0) && this.isShowTooltip) {
            games[item]['showTooltip'] = true;
            this.isShowTooltip = false;
          }
          if (games[item].c2_id) games[item]['c2'] = this.dict.cmd[games[item].c2_id];
          this.lineGames.set(item, games[item]);

          if (Array.isArray(games[item].statistical_ids)) {
            this.addStatisticalCategories(games[item].id, games[item].statistical_ids);
          }
        }
        if (this.mode === 'line' && this.lineGames.get(item).sr && Number(this.lineGames.get(item).ross_count)) _g.push(Number(item));
      }
      if (this.mode === 'line') this.loadLineRoss(_g);
    }
  }

  @action addGameDetails(tables, { withoutExtraFilters = [] } = {}) {
    let g;
    if (tables && !Array.isArray(tables.order)) {
      for (let item in tables) {
        item = Number(item);
        if (
          this.userToggleRoss.indexOf(item) !== -1 ||
          this.userToggleRoss.indexOf(Number((this.lineGames.get(item) || {}).parent_game_id)) !== -1 ||
          this.selected.games.length === 1
        ) {
          if (tables[item].data) this.copyGameTables(item, tables[item].data);
          if (tables[item].other) this.copyGameOther(item, tables[item].other);
          if (tables[item].filter) this.setTableFilters(item, tables[item].filter, { withoutExtraFilters });
          if (tables[item].f_l) this.setFirstLine(item, tables[item].f_l);
        }
      }
    } else {
      this.lineGamesDetails.clear();
      this.lineGamesOther.clear();
      this.firstLine.clear();
      this.filterTables.clear();
    }
  }

  @action checkGamesUpdate() {
    let i, j;
    if (this.selected.type == 1) {
      for (i of this.selected.sport) {
        j = this.lineSport.filter(item => item.id == i);
        if (j) {

        }
      }
    }
  }

  HIDE_WIDTH = 300;

  @action getVisibleTableIDs(order = [], data = {}, gameID) {
    if (!order && !order.length) {
      return [];
    }

    // sfs - флаг необходимости отображения таблицы внутри основного
    const visibleTableIDs = order.filter(order => data[order].data.sfs);
    if (visibleTableIDs.length > 0) {
      return visibleTableIDs;
    }

    // if (this.allOpenedStatisticalRossIDs.includes(`${gameID}`)) {
    //   return order.filter(order => data[order].data.sfs);
    // }

    const width = window.innerWidth;
    return order.filter((order) => {
      const { cls_vis = '', fbt } = data[order].data || {};
      return !(width > this.HIDE_WIDTH && cls_vis.indexOf('col-sm') !== -1) && fbt;
    });
  }

  @action copyGameTables(item, tables) {
    let order = [];
    const tablesOdred = this.getVisibleTableIDs(tables.order, tables.data, item);

    if (this.lineGamesDetails.has(item) && this.lineGamesDetails.get(item).order.length == this.colCount) {
      let _o = mobx.toJS(this.lineGamesDetails.get(item).order);
      const _s = _.pullAll(tablesOdred, _.flattenDeep(_o));
      if (_s.length) {
        if (_s.length == 1) {
          _o[0].push(_s[0]);
        } else {
          _o = _o.map((arr, i) => {
            const _d = arr;
            _s.forEach((x, indx) => {
              if (indx % this.colCount == i) {
                _d.push(x);
              }
            });
            return _d;
          });
        }
      }
      order = _o;
    } else {
      if (tablesOdred.length == 1) {
        order.push([tablesOdred[0]]);
      } else {
        for (let i = this.colCount; i > 0; i--) {
          const _t = [];
          tablesOdred.forEach((x, indx) => {
            const _d = tablesOdred[this.colCount * indx - i];
            if (_d) _t.push(_d);
          });
          order.push(_t);
        }
      }
    }
    this.lineGamesDetails.set(item, {
      order,
      originalOrder: tables.order,
      data: tables.data,
    });
  }

  @action placeForColTables(arr) {

    for (const i of arr) {

    }
  }

  @action copyGameOther(item, other) {
    this.lineGamesOther.set(item, other);
  }

  @action setFirstLine(item, firstLine) {

    if (this.firstLine.has(item)) {
      if (!firstLine) {
        this.firstLine.delete(item);
        return;
      }
      const f = mobx.toJS(this.firstLine.get(item));
      if (f.length > 0) {
        f.filter((_, lineIndex) => !!firstLine[lineIndex])
          .forEach((line, lineIndex) => {
            line.filter((coef, coefIndex) => !_.isEqual(coef, firstLine[lineIndex][coefIndex]))
              .forEach((_, coefIndex) => {
                this.firstLine.get(item)[lineIndex][coefIndex] = firstLine[lineIndex][coefIndex];
              });
          });
      }
    } else {
      this.firstLine.set(item, firstLine);
    }
  }

  @action setTableFilters(item, filters, { withoutExtraFilters = [] } = {}) {
    const isWithoutExtraFilters = withoutExtraFilters.includes(`${item}`);

    if (this.filterTables.has(item)) {
      const f = this.filterTables.get(item);
      filters.order.map(i => {
        if (f.filter[i]) {
          if (f.filter[i].count != filters.data[i].count) {
            this.filterTables.get(item).filter[i].count = filters.data[i].count;
          }
          if (_.xor(filters.data[i].tids, f.filter[i].tids).length) {
            this.filterTables.get(item).filter[i].tids = filters.data[i].tids;
          }
        } else {
          this.filterTables.get(item).filter[i] = {
            name: filters.data[i].n,
            count: filters.data[i].count,
            select: Number(isWithoutExtraFilters),
            tids: filters.data[i].tids,
          };
        }
      });
      if (!isWithoutExtraFilters) {
        filters.order.unshift(0);
      }
      this.filterTables.get(item).order = filters.order;
    } else {
      const { sid } = this.lineGames.has(item) ? this.lineGames.get(item) : { sid: 0 };
      const selectedFilter =
        this.defaultMainTab &&
        this.defaultMainTab.has(sid) &&
        filters.order.filter(id => this.defaultMainTab.get(sid).includes(id));
      const filter = {};
      if (!isWithoutExtraFilters) {
        filter[0] = {
          name: 'Все',
          select: +(!selectedFilter || !selectedFilter.length),
          count: 0
        };
      }
      filters.order.forEach(i => {
        filter[i] = {};
        filter[i].name = filters.data[i].n;
        filter[i].count = filters.data[i].count;
        filter[i].select = isWithoutExtraFilters ? 1 : +(selectedFilter && selectedFilter.includes(i));
        filter[i].tids = filters.data[i].tids;
      });
      if (!isWithoutExtraFilters) {
        filters.order.unshift(0);
      }
      const data = {
        filter,
        order: filters.order
      };
      this.filterTables.set(item, data);
    }
  }

  @action copyGame(item, game) {
    const lineGame = mobx.toJS(this.lineGames.get(item));
    lineGame.f_l.map((x, idx) => {
      if (!_.isEqual(x, game.f_l[idx])) {
        this.lineGames.get(item).f_l[idx] = game.f_l[idx];
      }
    });

    ['ross', 'score', 'st', 'date', 'hd', 'tv', 'video_type', 'video', 'is_video', 'stats'].forEach(
      f => {
        if (lineGame[f] !== game[f]) {
          this.lineGames.get(item)[f] = game[f];
        }
      },
    );

    // if (lineGame.ross != game.ross) {
    //   this.lineGames.get(item).ross = game.ross;
    // }
    //
    // if (lineGame.score != game.score) {
    //   this.lineGames.get(item).score = game.score;
    // }
    //
    // if (lineGame.st != game.st) {
    //   this.lineGames.get(item).st = game.st;
    // }
    //
    // if (game['hd']) {
    //   this.lineGames.get(item)['hd'] = game['hd'];
    // }

    if (this.lineGames.get(item).ross == 0) {
      this.firstLine.delete(item);
      this.filterTables.delete(item);
      this.lineGamesDetails.delete(item);
      this.lineGamesOther.delete(item);
    }

    // if ( lineGame.ross != game.ross) {
    // 	this.lineGames.get(item).ross = game.ross;
    // }
    // this.lineGames.get(item).sr = this.ross;

    const statisticalCategories = this.statisticalCategories.get(item);
    if (statisticalCategories || game.statistical_ids) {
      const hasSomeDifferentStatisticalCategory = typeof statisticalCategories === 'undefined'
        ? false
        : statisticalCategories.some(({ id }, index) => {
          const statisticalIDs = game.statistical_ids || [];
          const foundMatchID = (statisticalIDs[index] || {}).id;

          return id === `${foundMatchID}`;
        });

      if ((statisticalCategories || []).length !== (game.statistical_ids || []).length || hasSomeDifferentStatisticalCategory) {
        this.addStatisticalCategories(item, game.statistical_ids);
      }
    }
  }

  @action toogleShowTableItems(id) {
    this.lineLeague.get(id).show = !this.lineLeague.get(id).show;
  }

  @action toggleAllLeagueShow() {
    this.showTableItemsAll = !this.showTableItemsAll;
    this.lineLeague.keys().forEach(i => {
      this.lineLeague.get(i).show = this.showTableItemsAll;
    });
    if (this.showTableItemsAll) {
      this.loadMore();
    }
    // this.lineLeague.get(id).show = !this.lineLeague.get(id).show;
  }

  setToggleGames(gid, sid) {
    if (this.toggleRossGames.has(sid)) {
      const arr = toJS(this.toggleRossGames.get(sid));
      this.toggleRossGames.set(sid, Array.isArray(gid) ? [...arr, ...gid] : [...arr, gid]);
    } else {
      this.toggleRossGames.set(sid, Array.isArray(gid) ? gid : [gid]);
    }
  }

  removeToggleGames(gid, sid, clear) {
    if (clear) {
      this.toggleRossGames.clear();
      return null;
    }
    if (!this.toggleRossGames.has(sid)) return null;
    this.toggleRossGames.set(
      sid,
      _.pullAll(Array.isArray(gid) ? gid : toJS(this.toggleRossGames.get(sid)), [gid]),
    );
    return true;
  }

  getToggleGames(sid) {
    return this.toggleRossGames.has(sid) ? this.toggleRossGames.get(sid) : null;
  }

  @action toogleShowDop(id, type) {
    switch (type) {
      case 0:
        const { games } = this.lineLeague.get(id);
        if (!games.some(gameID => this.lineGames.get(gameID).sr)) {
          const gameIDs = [];
          games.forEach(gameID => {
            const game = this.lineGames.get(gameID);
            if (game.ross) {
              game.sr = 1;
              this.userToggleRoss.push(gameID);
              this.setToggleGames(gameID, game.sid);
              gameIDs.push(gameID);
            }
          });

          this.loadLineRoss(gameIDs);
          break;
        } else {
          games.map(gameID => {
            const game = this.lineGames.get(gameID);
            if (game.ross) {
              game.sr = 0;
              this.removeToggleGames(gameID, game.sid);
            }
          });
        }
        break;
      case 1:
        const game = this.lineGames.get(id);
        game.sr = !game.sr;

        if ((game.statistical_ids || []).length > 0) {
          this.setDefaultActiveStatisticalCategory(id);
        }

        if (this.ross && game.sr) {
          this.loadLineRoss([id]);
          return;
        }
        if (this.ross) {
          return;
        }
        const index = this.userToggleRoss.indexOf(id);
        if (index == -1) {
          this.userToggleRoss.push(id);
          this.setToggleGames(id, game.sid);
          this.loadLineRoss([id]);
          return;
        }
        this.userToggleRoss.splice(index, 1);
        this.removeToggleGames(id, game.sid);
        break;
    }
  }

  @action getHeadTable(id) {
    return this.lineGames.get(this.lineLeague.get(id).games[0]).hd;
  }

  @action isDopBets(id) {
    // return this.lineLeague[id].games.map((item) => (this.lineLeague))
  }

  @action setfilterTable(gameID, categoryID) {
    const filterTable = this.filterTables.get(gameID);
    if (categoryID == 0) {
      for (const i in filterTable.filter) {
        filterTable.filter[i].select = 0;
      }
      filterTable.filter[0].select = 1;
    } else {
      let check = 0;
      filterTable.filter[categoryID].select = !filterTable.filter[categoryID].select;
      for (const i in filterTable.filter) {
        if (i != 0 && filterTable.filter[i].select != 0) {
          check = 1;
          break;
        }
      }
      filterTable.filter[0].select = !check ? 1 : 0;
    }
    this.rePrintTable(gameID);
  }

  @action rePrintTable(gameID) {
    const lineGamesDetails = this.lineGamesDetails.get(gameID);
    let orderTableIDs = this.getVisibleTableIDs(toJS(lineGamesDetails.originalOrder), toJS(lineGamesDetails.data), gameID);

    if (this.filterTables.has(gameID)) {
      const filter = this.filterTables.get(gameID);

      if ((filter.filter[0] || {}).select !== 1) {
        const filtersData = toJS(filter.filter);
        let filterTableIDs = [];
        Object.values(filtersData).forEach(filterData => {
          if (filterData.select && (filterData.tids || []).length > 0 && Array.isArray(filterData.tids)) {
            filterTableIDs = filterTableIDs.concat(filterData.tids);
          }
        });
        orderTableIDs = intersection(orderTableIDs, filterTableIDs);
      }
    }

    const order = [];
    lineGamesDetails.order = [];
    for (let i = this.colCount; i > 0; i--) {
      const groupTableIDs = [];
      orderTableIDs.forEach((tableID, index) => {
        const tableOnColumn = orderTableIDs[this.colCount * index - i];
        if (tableOnColumn) {
          groupTableIDs.push(tableOnColumn);
        }
      });
      order.push(groupTableIDs);
    }

    if (orderTableIDs.length === 1) {
      order[0][0] = orderTableIDs[0];
    }

    lineGamesDetails.order = order;
  }

  @action getShowTable(cat_id, id) {
    if (this.filterTables.get(id).filter[0].select == 1) return 1;
  }

  @action selectGame(id) {
    this.store.menu.setSelect(id);
    this.selectItem({ sport: [this.lineGames.get(id).sid], league: [this.lineGames.get(id).lid], games: [id] }, 3);
  }

  @action selectItem(data, type) {

    this.all = this.mode == 'live' ? data.sport.length > 0 ? 0 : 1 : 0;
    this.selected.sport = data.sport;
    this.selected.league = data.league;
    this.selected.games = data.games;
    this.selected.popular_group = data.popular_group;
    this.selected.type = type;
    this.selected.video = data.video;

    if (this.selected.video) {
      this.lineLeague.clear()
      this.lineGames.clear()
    }

    if (data.games.length == 1) {
      this.ross = 1;
      if (this.lineGames.get(data.games[0])) this.lineGames.get(data.games[0]).sr = 1;
    } else {
      this.ross = this.mode == 'live' ? Number(this.account.accountSettings.loadRossLive) : 0;
      data.games.forEach(el => {
        if (this.lineGames.get(el) && this.userToggleRoss.indexOf(el) == -1) this.lineGames.get(el)['sr'] = 0;
      });
    }

    this.scrollTop();
    this.resetLoad();
  }

  scrollTop() {
    const div = document.getElementById('divmain');
    if (div) div.scrollTop = 0;
  }

  @computed get countSelectGames() {
    return this.selected.games.length;
  }

  @action resetLoad(clear = false) {
    clearInterval(this.refreshTimer);
    this.isLoading = true;
    this.lineSport = [];
    this.refreshTimer = null;
    this.offset = 0;
    this.hasMore = true;
    this.loadLine()
      .then(() => this.mode === 'live' && this.subscribeListMatchesWS())
      .then(action(() => { this.isLoading = !this.store.matchesList.isSubscribed; }))
      .catch(console.error)
      .then(() => { this.setData(); });
    ;
  }

  @action setDivmainScroll() {
    if (browser.mobile || browser.mac) {
      return;
    }
    const d = document.getElementById('divmain');
    if (d) {
      const ss = d.scrollHeight == d.offsetHeight;
      if (ss) {
        d.scrollTop = 0;
        setStyle('divmain-head', 'right', '0');
      } else {
        setStyle('divmain-head', 'right', '10px');
      }
    }
  }

  @action refreshSelected() {
    let league = [];
    let games = [];
    if (this.selected.type == 1) {
      this.selected.sport.forEach(item => {
        league = this.store.menu.sport.get(item).league;
        league.forEach(item => {
          games = games.concat(this.store.menu.league.get(item).games.peek());
        });
      });
      this.selected.league = league;
      this.selected.games = games;
    }
    if (this.selected.type == 2) {
      this.selected.legue.forEach(item => {
        games = games.concat(this.store.menu.league.get(item).games.peek());
      });
      this.selected.games = games;
    }
  }

  @action filterLine(value) {
    this.timeLine = value;
    this.resetLoad();
  }

  getRossGamesLoad() {
    let _gids = [];

    if (this.mode === 'live' && this.all) {
      _gids = toJS(this.userToggleRoss);
    } else {
      this.selected.sport.forEach(sid => {
        if (this.toggleRossGames.has(sid)) {
          _gids = _gids.concat(toJS(this.toggleRossGames.get(sid)));
        }
      });

      if (this.selected.games.length > 0)
        _gids = _.intersectionWith(this.selected.games, _gids, (x, y) => x == y);
      _gids = _.intersectionWith(this.userToggleRoss, _gids, (x, y) => x == y);
    }

    return _gids;
  }

  @action addStatisticalCategories(gameID, newStatisticalCategories) {
    const statisticalCategories = newStatisticalCategories
      .sort((a, b) => {
        if (Number(a.stat_type) < Number(b.stat_type)) {
          return -1;
        }
        if (Number(a.stat_type) > Number(b.stat_type)) {
          return 1;
        }
        return 0;
      })
      .map(({
        id,
        base_stat,
        name_stas,
        ross_count,
      }) => ({
        id: `${id}`,
        name: name_stas,
        count: Number(ross_count),
        isActive: false,
        ...(base_stat === 1 && { isPrimary: true }),
      }));

    const primaryStatisticalCategories = statisticalCategories.filter(({ isPrimary }) => isPrimary);
    const secondaryStatisticalCategories = statisticalCategories.filter(({ isPrimary }) => !isPrimary);


    primaryStatisticalCategories.unshift({
      id: `${gameID}`,
      name: 'MATCH',
      isActive: false,
      isLocaleKey: true,
    });
    if (secondaryStatisticalCategories.length > 0) {
      primaryStatisticalCategories.push({
        id: secondaryStatisticalCategories.map(({ id }) => id).join('-'),
        name: 'STATISTICS',
        count: secondaryStatisticalCategories.reduce((memo, { count }) => memo + (count || 0), 0),
        isActive: false,
        isLocaleKey: true,
        categories: secondaryStatisticalCategories,
      });
    }

    const currentStatisticalCategory = this.statisticalCategories.get(gameID);
    if (currentStatisticalCategory) {
      const currentPrimaryStatisticalCategoryID = (currentStatisticalCategory.find(({ isActive }) => isActive) || {}).id;
      primaryStatisticalCategories.find(({ id }) => id === `${currentPrimaryStatisticalCategoryID || gameID}`).isActive = true;

      const currentSecondaryStatisticalCategories = this.getSecondaryStatisticalCategories(currentStatisticalCategory);
      if (currentSecondaryStatisticalCategories.length > 0) {
        const currentSecondaryStatisticalCategoryID = (currentSecondaryStatisticalCategories.find(({ isActive }) => isActive) || {}).id;
        const secondaryStatisticalCategories = this.getSecondaryStatisticalCategories(primaryStatisticalCategories);
        const secondaryStatisticalCategory = secondaryStatisticalCategories.find(({ id }) => id === currentSecondaryStatisticalCategoryID);

        (secondaryStatisticalCategory || secondaryStatisticalCategories[0]).isActive = true;
      }
    }

    this.statisticalCategories.set(gameID, primaryStatisticalCategories);

    if (typeof currentStatisticalCategory === 'undefined') {
      this.setDefaultActiveStatisticalCategory(gameID);
    }
  }

  getActiveStatisticalCategoryID = (gameID) => {
    const activePrimaryStatisticalCategory = (this.statisticalCategories.get(gameID) || []).find(({ isActive }) => isActive) || {};
    if (typeof activePrimaryStatisticalCategory.categories !== 'undefined') {
      const id = activePrimaryStatisticalCategory.categories.find(({ isActive }) => isActive).id;
      return Number(id);
    }

    return Number(activePrimaryStatisticalCategory.id || gameID);
  }

  getSecondaryStatisticalCategories = (statisticalCategories = []) => {
    const secondaryStatisticalCategories = statisticalCategories.find(({ categories }) => typeof categories !== 'undefined') || {};
    return secondaryStatisticalCategories.categories || [];
  }

  @action setDefaultActiveStatisticalCategory(gameID) {
    const statisticalCategories = this.statisticalCategories.get(gameID) || [];
    if (statisticalCategories.length > 0) {
      statisticalCategories.forEach(category => category.isActive = false);
      statisticalCategories[0].isActive = true;

      const secondaryStatisticalCategories = this.getSecondaryStatisticalCategories(statisticalCategories);
      if (secondaryStatisticalCategories.length > 0) {
        secondaryStatisticalCategories.forEach(category => category.isActive = false);
        secondaryStatisticalCategories[0].isActive = true;
      }
    }
  }

  @action async selectPrimaryStatisticalCategory(gameID, categoryID) {
    const statisticalCategories = this.statisticalCategories.get(gameID);
    const prevStatisticalCategoryID = statisticalCategories.find(({ isActive }) => isActive).id;
    const isSameID = prevStatisticalCategoryID === categoryID;
    if (isSameID) {
      return null;
    }

    if (!this.store.matchesList.outcomes.isSubscribed(gameID)) {
      await this.loadRossByPrimaryStatisticalCategory(gameID, categoryID);
    }

    runInAction(() => {
      statisticalCategories.forEach(category => category.isActive = category.id === categoryID);
    });
  }

  @action async loadRossByPrimaryStatisticalCategory(gameID, ids, { isRefresh = false } = {}) {
    const normalizedIDs = ids.split('-');
    if (normalizedIDs.length === 0) {
      return null;
    }

    if (!isRefresh) {
      this.statisticalCategoriesLoading.push(gameID);
    }
    let response = {};
    const isStatisticGame = normalizedIDs.length > 1 || this.allOpenedStatisticalRossIDs.includes(`${normalizedIDs[0]}`);
    response = await api[this.mode].getRoss(normalizedIDs, Number(isStatisticGame));

    runInAction(() => {
      const tables = (response || {}).t_b;
      if (tables) {
        const tableIDs = Object.keys(tables);
        const secondaryStatisticalCategories = (this.statisticalCategories.get(gameID) || []).find(({ categories }) => typeof categories !== 'undefined');
        const withoutExtraFilters = secondaryStatisticalCategories ? secondaryStatisticalCategories.id.split('-') : [];

        tableIDs.forEach(id => {
          const numberID = Number(id);
          if (!this.lineGames.has(numberID)) {
            this.lineGames.set(numberID, {
              sid: this.lineGames.get(gameID).sid,
              parent_game_id: gameID,
            });
          }
        });

        this.addGameDetails(tables, { withoutExtraFilters });
      }

      if (!isRefresh) {
        this.statisticalCategoriesLoading = this.statisticalCategoriesLoading.filter(id => id !== gameID);
      }
    });
  }

  @computed get allOpenedStatisticalRossIDs() {
    const openedRossIDs = [];
    this.lineGames.forEach(({ sr }, id) => {
      if (sr) {
        openedRossIDs.push(id);
      }
    });

    const allOpenedStatisticalRossIDs = [];
    openedRossIDs.forEach(rossID => {
      (this.statisticalCategories.get(rossID) || []).forEach(({ id, categories }, index) => {
        if (index > 0) {
          typeof categories === 'undefined'
            ? allOpenedStatisticalRossIDs.push(id)
            : allOpenedStatisticalRossIDs.push(...categories.map(({ id }) => id));
        }
      });
    });

    return allOpenedStatisticalRossIDs;
  }

  @action selectSecondaryStatisticalCategory(gameID, categoryID) {
    const statisticalCategories = this.statisticalCategories.get(gameID);
    const secondaryStatisticalCategories = this.getSecondaryStatisticalCategories(statisticalCategories);
    const prevStatisticalCategoryID = secondaryStatisticalCategories.find(({ isActive }) => isActive).id;
    if (prevStatisticalCategoryID === categoryID) {
      return null;
    }

    secondaryStatisticalCategories.forEach(category => category.isActive = category.id === categoryID);
  }

  refreshRossStatisticalTables = () => {
    let rossGameIDs = [];
    if (this.userToggleRoss.length > 0) {
      rossGameIDs = this.userToggleRoss;
    } else if (this.selected.games.length === 1) {
      rossGameIDs = this.selected.games;
    }

    rossGameIDs.forEach((id) => {
      if (this.store.matchesList.outcomes.isSubscribed(id)) { return; }

      const statisticalCategories = this.statisticalCategories.get(id);
      if (typeof statisticalCategories !== 'undefined') {
        const activePrimaryStatisticalCategory = statisticalCategories.find(({ isActive }) => isActive);
        this.loadRossByPrimaryStatisticalCategory(id, activePrimaryStatisticalCategory.id, { isRefresh: true });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/stores/lineStore/line.js